import 'regenerator-runtime/runtime';
import 'current-script-polyfill';
import 'bootstrap';
import 'blocks/bootstrap.less';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'blocks/migration/list.scss'; // escoList .panel
import 'blocks/migration/errors.css';
import '@selectize/selectize/dist/css/selectize.bootstrap3.css';
import 'blocks/style.css';
import { addConfigFromSolutions } from 'blocks/solutions/solutions';

const init = async () => {
  await addConfigFromSolutions();
  // eslint-disable-next-line import/extensions
  const initDefaults = await import(/* webpackChunkName: "initDefaults" */ './defaults.js');
  await initDefaults.default();
};

export default init();
